<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    placeholder="请选择坯布"/>
</template>

<script>
  /**
   * @description 坯布自动查询组件
   * @author: 菩萨蛮
   * @date 2020/3/9 3:23 下午
   * @version V1.0.0
   *
   * 公司的业务千篇一律，复杂的代码好几百行
   */
  import AutoComplete from '../../../mixins/common/AutoComplete';

  export default {
    name: 'ArtAutoComplete',
    mixins: [AutoComplete],
    data() {
      return {
        url: '/base/info/greige/art?pageSize=5&pageNum=0&code=',
        itemName: 'code'
      };
    }
  };
</script>

<style lang="scss" scoped>

</style>
